// SourcesChart - Leads by source pie chart
import { Paper, Title, Text, Stack } from '@mantine/core';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import type { LeadsBySource } from '@/types/models/lead.types';

interface SourcesChartProps {
  data: LeadsBySource[];
  isLoading?: boolean;
}

const COLORS = [
  '#2196f3',
  '#ff9800',
  '#4caf50',
  '#f44336',
  '#9c27b0',
  '#00bcd4',
  '#ffeb3b',
  '#795548',
];

export const SourcesChart = ({ data, isLoading }: SourcesChartProps) => {
  if (isLoading || !data || data.length === 0) {
    return (
      <Paper withBorder p="md" radius="md" style={{ minHeight: 400 }}>
        <Stack align="center" justify="center" style={{ minHeight: 350 }}>
          <Text c="dimmed">
            {isLoading ? 'Loading chart data...' : 'No data available'}
          </Text>
        </Stack>
      </Paper>
    );
  }

  const chartData = data.map((item) => ({
    name: item.source.charAt(0).toUpperCase() + item.source.slice(1),
    value: item.count,
    percentage: item.percentage,
  }));

  return (
    <Paper withBorder p="md" radius="md">
      <Title order={3} mb="md">
        Leads by Source
      </Title>
      <ResponsiveContainer width="100%" height={350}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }: any) => `${name}: ${(percent * 100).toFixed(1)}%`}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              backgroundColor: '#fff',
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
            }}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Paper>
  );
};
